import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
//import components
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Input,
    FormGroup,
} from "reactstrap"
import DeleteModel from "common/deleteModel/deleteModel"
import { dateFormat } from "pages/Common"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import { useLocation } from "react-router-dom"
import { routes } from "routes/path"
import ManufactureProductTable from "./ManufactureProductTable"
import { exportDataExcel } from "pages/ExportData"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumb from "components/Common/Breadcrumb"


const ManufactureProductList = () => {
    let { pathname } = useLocation()
    const { deleteApi, postApi, putApi, getApi } = useApi()
    document.title = `Manufacture Products | ${localStorage.getItem("ShopName")}`
    const navigate = useNavigate()
    // useStates
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [TotalRecords, setTotalRecords] = useState(0)
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [categories, setCategories] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [searchText, setSearchText] = useState("")
    const [categoryId, setCategoryId] = useState(0)
    const [isRetire, setIsRetire] = useState(false)
    const [isInStock, setIsInStock] = useState(false)
    const [isWashing, setIsWashing] = useState(false)
    const [displayStart, setDisplayStart] = useState(1)
    const [isTaken, setIsTaken] = useState(false)
    const [date, setdate] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(false)
    const [branches, setBranches] = useState([])
    const [filterUserId, setFilterUserId] = useState(0)
    const [RoleId, setRoleId] = useState(
        JSON.parse(localStorage.getItem("authUser"))
    )
    // filterData for Product
    const filterData = textFilter => {
        setSearchText(textFilter)
    }

    useEffect(() => {
        setIsLoading(true)
        getApi(`Category/category-lookup?categoryId=${0}`).then(({ data, status }) => {
            if (status === 200) {
                data.unshift({
                    Value: "All Category",
                    Key: 0
                });
                setCategories(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
        })
        if (RoleId?.RoleId == 4) {
            getApi("User/user-lookup").then(({ data, status }) => {
                if (status === 200) {
                    setIsLoading(false)
                    const filteredData = data.filter(item => item.Key !== 1);
                    setBranches(filteredData);
                } else {
                    setIsLoading(false)
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        } else {
            getApi("User/manufacture-lookup").then(({ data, status }) => {
                if (status === 200) {
                    setIsLoading(false)
                    const filteredData = data.filter(item => item.Key !== 1);
                    setBranches(filteredData);
                } else {
                    setIsLoading(false)
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        }

    }, [])

    // pagination
    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setIsLoading(true)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
    }

    const ManufacturingProductsListApi = () => {
        setIsLoading(true)
        postApi("product/manufacturing-product/list", {
            FilterUserId: filterUserId,
            FromDate: !dateDisble
                ? null
                : date[0]
                    ? dateFormat(date[0], "yyyy-MM-dd")
                    : new Date().toISOString().slice(0, 10),
            ToDate: !dateDisble
                ? null
                : date[1]
                    ? dateFormat(date[1], "yyyy-MM-dd")
                    : new Date().toISOString().slice(0, 10),
            DisplayStart: displayStart,
            PageSize: rowsPerPage,
            SearchText: searchText,
            SortColumn: "",
            SortOrder: "",
            IsTaken: isTaken,
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data.ProductList)
                setTotalRecords(data.TotalRecords)
                setIsLoading(false)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
                setIsLoading(false)
            }
        })
    }

    useEffect(() => {
        if (date[1] != undefined) {
            ManufacturingProductsListApi()
        }
    }, [displayStart, rowsPerPage, searchText, isTaken, filterUserId, dateDisble, date])


    // product delete handler
    const handleDelete = productId => {
        setIsLoading(true)
        if (productId) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this product permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`product/manufacturing-product/delete?id=${productId}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== productId ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Product sucessfully deleted", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Product",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }
    }

    // product edit Id handler
    const editRow = (data) => {
        if (data?.Id) {
            navigate(routes.updatemanufactureProduct, {
                state: {
                    data,
                },
            })
        }
    }

    const handleCreateProduct = (data) => {
        if (data?.Id) {
            navigate(routes.createProduct, {
                state: {
                    data,
                },
            })
        }
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Branch",
                accessor: "BranchUserName",
                width: "8%",
            },
            {
                Header: "Name",
                accessor: "Name",
                Cell: ({ row }) => (
                    <span>
                        {row.original.Name ? row.original.Name : "N/A"}
                    </span>
                ),
            },
            {
                Header: "Category",
                accessor: "CategoryName",
                width: "6%",
                Cell: ({ row }) => (
                    <span>
                        {row.original.CategoryName ? row.original.CategoryName : "N/A"}
                    </span>
                ),
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        Rent
                    </div>
                ),
                accessor: "Rent",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.Rent || 0)}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        MRP
                    </div>
                ),
                accessor: "MRP",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.MRP || 0)}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        M_Cost
                    </div>
                ),
                accessor: "M_Cost",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.M_Cost || 0)}
                        </div>
                    )
                },
            },
            {
                Header: "Remarks",
                accessor: "Remarks",
                width: "10%",
                Cell: ({ row }) => (
                    <span
                        className="mb-0"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={`${row.original.Remarks == null ? '' : row.original.Remarks}`}
                    >
                        {row.original.Remarks?.length > 15
                            ? `${row.original.Remarks?.substr(0, 15)}...`
                            : row.original.Remarks == ""
                                ? "N/A"
                                : row.original.Remarks == null
                                    ? "N/A"
                                    : row.original.Remarks}
                    </span>
                ),
            },
            {
                Header: "Date",
                accessor: "CreatedOn",
                width: "8%",
                Cell: ({ row }) => (
                    <span>
                        {row.original.CreatedOn.split("T")[0] == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original.CreatedOn, "dd/MM/yyyy")}
                    </span>
                ),
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "8%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            {RoleId?.RoleId == 4 ?
                                <>
                                    {row.original.IsTaken ?
                                        <>
                                            <li className="mytooltip">
                                                <i
                                                    className=" fs-6 fas fa-edit btn-edit"
                                                    id={`edittooltip`}
                                                    style={{ cursor: "not-allowed", color: "#808080b3" }}
                                                ></i>
                                                <span className="mytext">Edit</span>
                                            </li>
                                            <li className="mytooltip">
                                                <i
                                                    className="fs-6 fas fa-trash-alt btn-delete"
                                                    id={`edittooltip`}
                                                    style={{ cursor: "not-allowed", color: "#808080b3" }}
                                                ></i>
                                                <span className="mytext">Delete</span>
                                            </li>
                                        </>

                                        :
                                        <>
                                            < li className="mytooltip">
                                                <i
                                                    className=" fs-6 fas fa-edit btn-edit"
                                                    id={`edittooltip${row.original.Id}`}
                                                    onClick={() => editRow(row.original)}
                                                ></i>
                                                <span className="mytext">Edit</span>
                                            </li>
                                            <li className="mytooltip">
                                                <i
                                                    className="fs-6 fas fa-trash-alt btn-delete"
                                                    id={`deletetooltip${row.original.Id}`}
                                                    onClick={() => handleDelete(row.original.Id)}
                                                ></i>
                                                <span className="mytext">Delete</span>
                                            </li>
                                        </>
                                    }
                                </> :
                                <>
                                    {
                                        row.original.IsTaken ?
                                            <li className="mytooltip">
                                                <i
                                                    className="bx bx-list-plus"
                                                    id={`edittooltip`}
                                                    style={{ cursor: "not-allowed", color: "#808080b3", fontSize: "20px" }}
                                                ></i>
                                                <span className="mytext">Create Product</span>
                                            </li>
                                            :
                                            <li className="mytooltip">
                                                <i
                                                    className="bx bx-list-plus"
                                                    id={`createproducttooltip${row.original.Id}`}
                                                    style={{ color: "blue", fontSize: "20px" }}
                                                    onClick={() => handleCreateProduct(row.original)}
                                                ></i>
                                                <span className="mytext">Create Product</span>
                                            </li>
                                    }
                                </>
                            }
                        </ul >
                    )
                },
            },
        ],
        [tableData, TotalRecords]
    )

    // redirect create product handler
    const handleUserClicks = () => {
        navigate(routes.createmanufactureProduct)
    }

    function writeDataToExcel() {
        setIsLoading(true)
        let header = ["Branch", "Name", "Category", "Rent", "MRP", "M_Cost", "Create Date", "Remarks"];
        const mainTitle = "Manufacture Product";
        const widthObj = [
            {
                Key: "A",
                Value: 15,
            },
            {
                Key: "B",
                Value: 20,
            },
            {
                Key: "C",
                Value: 18,
            },
            {
                Key: "D",
                Value: 12,
            },
            {
                Key: "E",
                Value: 12,
            },
            {
                Key: "F",
                Value: 12,
            },
            {
                Key: "G",
                Value: 15,
            },
            {
                Key: "H",
                Value: 20,
            },

        ]

        const extention = "Manufacture_Product.xlsx"
        postApi("product/manufacturing-product/list", {
            FilterUserId: filterUserId,
            FromDate: !dateDisble
                ? null
                : date[0]
                    ? dateFormat(date[0], "yyyy-MM-dd")
                    : new Date().toISOString().slice(0, 10),
            ToDate: !dateDisble
                ? null
                : date[1]
                    ? dateFormat(date[1], "yyyy-MM-dd")
                    : new Date().toISOString().slice(0, 10),
            DisplayStart: 1,
            PageSize: 100000,
            SearchText: searchText,
            SortColumn: "",
            SortOrder: "",
            IsTaken: isTaken,
        }).then(({ data, status }) => {
            if (status === 200) {
                setIsLoading(false)
                setTotalRecords(data.TotalRecords)
                let excelSheetData = []
                for (let index = 0; index < data.ProductList.length; index++) {
                    let dataObj = {
                        Branch: data.ProductList[index].BranchUserName,
                        Name: data.ProductList[index].Name,
                        Category: data.ProductList[index].CategoryName,
                        Rent: (data.ProductList[index].Rent).toFixed(2),
                        MRP: (data.ProductList[index].MRP).toFixed(2) || 0,
                        M_Cost: (data.ProductList[index].M_Cost).toFixed(2) || 0,
                        CreatedOn: dateFormat(data.ProductList[index].CreatedOn.split("T")[0],
                            "dd/MM/yyyy"),
                        Remarks: data.ProductList[index].Remarks || "N/A",
                    }
                    excelSheetData.push(dataObj)
                }
                var fields = Object.keys(excelSheetData[0]);
                var sheetData = excelSheetData.map(function (row) {
                    return fields.map(function (fieldName) {
                        return row[fieldName];
                    });
                });
                sheetData.unshift(header);
                exportDataExcel(sheetData, mainTitle, widthObj, extention, 0, 0, 0, 0, 0, 0)

            } else {
                setIsLoading(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {isLoading && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumb
                    title={breadcrumbs[pathname].title}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                />
                <Card>
                    <CardBody>
                        <ManufactureProductTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isCreateProduct={true}
                            handleUserClick={handleUserClicks}
                            customPageSize={20}
                            writeDataToExcel={writeDataToExcel}
                            className="custom-header-css"
                            filterData={filterData}
                            pagePerSize={pagePerSize}
                            isLoading={isLoading}
                            TotalRecords={TotalRecords}
                            categories={categories}
                            isTaken={isTaken}
                            setIsTaken={setIsTaken}
                            setFilterUserId={setFilterUserId}
                            branches={branches}
                            filterUserId={filterUserId}
                            RoleId={RoleId}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            date={date}
                            setdate={setdate}
                        />
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}

ManufactureProductList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
}

export default ManufactureProductList